import styled from 'styled-components';

export const StandingWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${props => (props.fontSize ? props.fontSize : 'inherit')};
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  background-color: ${props => props.theme.colors.mainColor};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  border-top: 1px solid ${props => props.theme.colors.gray};
  margin: 0px 0px 10px 0px;
  padding: 10px 0;
`;

export const GradientWrapper = styled.div`
  /*position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 96%, rgba(255,255,255,1) 100%);
  background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 96%,rgba(255,255,255,1) 100%);
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 96%,rgba(255,255,255,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 );*/
`;



// WEBPACK FOOTER //
// ./src/containers/StandingWidget/styles.js